__turbopack_context__.v({
  "switch": "index-module-scss-module__KRKB_G__switch",
});
